<div calss="d-flex flex-column align-items-start" *ngIf="show">
    <button 
    class="btn primary save-changes-button d-none d-md-flex"
    (click)="openRelatedEditModal.emit()"
    i18n="@@common.saveChanges"
    >
    Save Changes
    </button>
  </div>
